import React from 'react';
import PropTypes from 'prop-types';

import TextShell from './TextShell';
import withPresets from '@xingternal/with-presets';
import * as skins from './heroSkins';

const Hero = ({ ...props }) => (
  <TextShell {...{ ...props, tag: props.tag || 'h1' }} />
);

Hero.propTypes = {
  tag: PropTypes.string,
};
export default withPresets(skins)(Hero);
